module.exports = __webpack_public_path__ + "static/media/suikerwafel.1c6f6c24.png";